import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-avoire-ticket-caisse',
  templateUrl: './avoire-ticket-caisse.component.html',
  styleUrls: ['./avoire-ticket-caisse.component.scss']
})
export class AvoireTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
